import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Clock, LogOut } from 'lucide-react';
import { useAuth } from '../auth/AuthContext';

export default function Pending() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get('next') ?? '/';

  useEffect(() => {
    if (user?.status === 'ACTIVE') navigate(next);
  }, [user?.status, next, navigate]);

  return (
    <div className="min-h-full flex items-center justify-center p-6">
      <div className="card p-8 w-full max-w-md text-center">
        <Clock className="mx-auto mb-4 text-amber-400" size={32} />
        <h1 className="text-xl font-semibold mb-2">Awaiting approval</h1>
        <p className="text-sm text-zinc-400 mb-6">
          Your account ({user?.phone}) is verified but pending admin approval. You'll receive an SMS
          when you're approved. This page refreshes automatically.
        </p>
        <button onClick={logout} className="btn-secondary mx-auto">
          <LogOut size={16} /> Sign out
        </button>
      </div>
    </div>
  );
}
